export enum WebhookEventType {
  ADMISSION_GROUP_CREATED = 'ADMISSION_GROUP_CREATED',
  ADMISSION_GROUP_UPDATED = 'ADMISSION_GROUP_UPDATED',
  RESERVATION_REQUEST_CREATED = 'RESERVATION_REQUEST_CREATED',
}

export enum WebhookEventTypeName {
  ADMISSION_GROUP_CREATED = 'Admission/Res Created',
  ADMISSION_GROUP_UPDATED = 'Admission/Res Updated',
  RESERVATION_REQUEST_CREATED = 'Reservation Request Created',
}
